module.exports = __webpack_public_path__ + "img/security-audit-img-1.4dc92ca1.jpg";